import { Delete } from "./Delete";
import { Download } from "./Download";
import { Edit } from "./Edit";
import Gfe from "../../../../../../../../Components/Clients/Documents/components/GfeButton";
import { Lock } from "./Lock";
import { Timer } from "./Timer";

export const Actions = {
  Download,
  Timer,
  Lock,
  Delete,
  Edit,
  Gfe,
};
